import { render, staticRenderFns } from "./BottomNavigationMobile.vue?vue&type=template&id=4153b121"
import script from "./BottomNavigationMobile.vue?vue&type=script&lang=js"
export * from "./BottomNavigationMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports